import { makeObservable, observable } from "mobx";
import { apiSwagger } from "../../shared/api";
import { triggerEvent } from "@/sharedTypes/pureHelpers";
// import { triggerEvent } from "../../helpers/pureHelpers";

class DebugModel {
    displayData: {
        username: string;
        date: string;
        uuid: string;
    }[] = []
    screenRecordingEnabled: boolean = false;

    constructor() {
        makeObservable(this, {
            displayData: observable,
            screenRecordingEnabled: observable
        })
    }

    toggleScreenRecording() {
        this.screenRecordingEnabled = !this.screenRecordingEnabled;
    }
    refreshUUIDS() {
        this.getAllUUIDs()
            .then((data) => {
                if (data !== null && "uuids" in data) {
                    const sortedData = data.uuids.sort(
                        (a: any, b: any) =>
                            (new Date(b.date) as any) - (new Date(a.date) as any),
                    );

                    this.displayData = sortedData
                    triggerEvent("debugDatasRefreshed")
                } else {
                    console.error('Error getting UUIDs.');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                throw (error)
            });
    }

    async getAllUUIDs() {
        const response = await apiSwagger.debugEvents.uuiDsList();
        if (response.ok) {
            return response.data;
        } else {
            if (response.error) {
                throw new Error(response.error.error);
            } 
            throw new Error("Failed to fetch UUIDs");
        }
    }
}

const DebugModelEntity = new DebugModel();
export default DebugModelEntity;
